/**
 * 省区简称按固定顺序拼接：京、津、冀、疆、蒙
 * 例：冀→冀，京冀→京冀，冀京→京冀，蒙津→津蒙
 * 全称（北京/河北等）或夹杂其它字的保持原样
 */
const REGION_ORDER = ['京', '津', '冀', '疆', '蒙']
const REGION_CHARS = new Set(REGION_ORDER)

export const normalizeRegionLabel = (raw) => {
    if (raw === undefined || raw === null) return ''
    const text = String(raw).trim()
    if (!text) return ''

    const compact = text.replace(/[、,，/／\-—_\s]/g, '')
    if (!compact) return text

    const chars = Array.from(compact)
    if (!chars.length) return text
    if (!chars.every(ch => REGION_CHARS.has(ch))) return text

    const unique = []
    chars.forEach(ch => {
        if (!unique.includes(ch)) unique.push(ch)
    })
    return REGION_ORDER.filter(ch => unique.includes(ch)).join('')
}

export const mergeRegionFilterTabs = (list, toCount) => {
    const rows = Array.isArray(list) ? list : []
    const merged = Object.create(null)

    rows.forEach((item, idx) => {
        const rawLabel = (item && item.label) || '未知'
        const name = normalizeRegionLabel(rawLabel) || rawLabel
        const count = typeof toCount === 'function' ? toCount(item && item.count) : Number(item && item.count) || 0
        const provinceIds = Array.isArray(item && item.provinceIds)
            ? item.provinceIds.filter(id => id !== undefined && id !== null && id !== '')
            : []

        if (!merged[name]) {
            merged[name] = {
                key: provinceIds.length
                    ? provinceIds.join('-')
                    : `region-${idx}-${name}`,
                name,
                count: 0,
                provinceIds: []
            }
        }
        merged[name].count += count
        provinceIds.forEach(id => {
            if (!merged[name].provinceIds.includes(id)) {
                merged[name].provinceIds.push(id)
            }
        })
    })

    return Object.keys(merged).map(key => merged[key])
}

export const mergeProvinceMetricRows = (list, { unit, toNumber, formatCount }) => {
    const rows = Array.isArray(list) ? list : []
    const merged = Object.create(null)

    rows.forEach((item, idx) => {
        const rawLabel = (item && item.provinceName) || '未知'
        const label = normalizeRegionLabel(rawLabel) || rawLabel
        const value = typeof toNumber === 'function'
            ? toNumber(item && item.count)
            : Number(item && item.count) || 0
        const key = `${label}__${(item && item.provinceId) || idx}`

        if (!merged[key]) {
            merged[key] = {
                provinceId: item && item.provinceId,
                label,
                value,
                _idx: idx
            }
        } else {
            merged[key].value += value
        }
    })

    const result = Object.keys(merged)
        .map(key => merged[key])
        .sort((a, b) => {
            if (b.value !== a.value) return b.value - a.value
            return a._idx - b._idx
        })

    const max = result.reduce((m, row) => Math.max(m, row.value), 0)
    return result.map(({ _idx, ...row }) => ({
        ...row,
        valueText: `${typeof formatCount === 'function' ? formatCount(row.value) : row.value} ${unit}`,
        percent: max > 0 ? Math.round((row.value / max) * 1000) / 10 : 0
    }))
}
